import { FC } from "react";
import Image from "next/image";

import Container from "../Container";
import Title from "../Title";
import Button from "../Button";

type ThreeImageIntroProps = {
  lang: any;
  images: string[];
  cta: {
    href: string;
    target?: string;
    rel?: string;
    label: string;
  };
};

export const ThreeImageIntro: FC<ThreeImageIntroProps> = ({
  lang,
  images,
  cta,
  ...rest
}) => {
  return (
    <section className="py-16 md:py-24" {...rest}>
      <Container className="flex flex-col items-center gap-[60px] lg:gap-12">
        <header className="lg:mb-20">
          <div className="mx-auto flex flex-col items-center text-center mb-10 lg:mb-20">
            {lang?.title && (
              <Title className="max-w-[21ch] text-2.5xl lg:text-3.5xl">
                {lang.title}
              </Title>
            )}
          </div>
          <div className="hidden lg:flex flex-row justify-center items-center gap-[30px] w-full">
            {images.map((image, index) => (
              <div key={index} className="w-1/3">
                <Image
                  src={image}
                  alt={`Intro Image ${index}`}
                  priority
                  className={`rounded-[5px] object-cover ${index !== 1 ? "aspect-square" : ""}`}
                />
              </div>
            ))}
          </div>
          <div className="hidden lg:flex flex-row justify-center items-start gap-[30px] w-full">
            {images.map((_, index) => (
              <div key={`text-${index}`} className="w-1/3">
                <h3 className="text-2xl font-semibold mt-12">
                  {lang?.sections[index].title}
                </h3>
                <p className="text-sm mt-5">{lang?.sections[index].body}</p>
              </div>
            ))}
          </div>
          <div className="lg:hidden flex flex-col gap-[60px]">
            {images.map((image, index) => (
              <div key={index} className="w-full">
                <Image
                  src={image}
                  alt={`Intro Image ${index}`}
                  priority
                  className="rounded-[5px] object-cover aspect-square"
                />
                <h3 className="text-xl font-semibold mt-[30px]">
                  {lang?.sections[index].title}
                </h3>
                <p className="text-sm mt-3">{lang?.sections[index].body}</p>
              </div>
            ))}
          </div>
        </header>

        {cta && <Button {...cta} />}
      </Container>
    </section>
  );
};
